export default "__VITE_ASSET__c9320d35__"